module.exports = __webpack_public_path__ + "static/007089-409b2dd1b09207205bf83cb2ec08b8a2.jpg";